// extracted by mini-css-extract-plugin
export default {"container":"Trees_container__1pBgv","content":"Trees_content__MM3b0"};